import React, { useState } from "react";
import axios from "axios";
import { Dropdown, Form } from "react-bootstrap";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { useSelector } from "react-redux";

const MultiSellerSelect = ({ items, selectedProductIds, setSelectedProductIds, lockedSellerId, setLockedSellerId }) => {

  const handleToggle = (item) => {
    let updated;

    if (selectedProductIds.includes(item.productId)) {
      updated = selectedProductIds.filter(
        (id) => id !== item.productId
      );
    } else {
      updated = [...selectedProductIds, item.productId];
    }

    if (updated.length === 0) {
      setLockedSellerId(null);
    } else {
      const firstItem = items.find(
        (i) => i.productId === updated[0]
      );
      setLockedSellerId(firstItem.sellerId);
    }

    setSelectedProductIds(updated);
  };

  return (
    <Dropdown className="mb-3 mt-2">
      <Dropdown.Toggle variant="outline" className="w-100 form-control border-light text-start">
        {selectedProductIds.length > 0
          ? `${selectedProductIds.length} item(s) selected`
          : "Select Items"}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="w-100"
        style={{ maxHeight: "250px", overflowY: "auto" }}
      >
        {items.map((item) => {
          const disabled =
            lockedSellerId !== null &&
            item.sellerId !== lockedSellerId;

          return (
            <Dropdown.Item
              as="div"
              key={item.productId}
              className="px-3"
            >
              <Form.Check
                type="checkbox"
                label={item.productName}
                checked={selectedProductIds.includes(item.productId)}
                disabled={disabled}
                onChange={() => handleToggle(item)}
              />
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const Dispute = ({ show, onClose, orderId, items }) => {
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [lockedSellerId, setLockedSellerId] = useState(null);
  const userData = useSelector((state) => state?.auth?.user?.user);

  if (!show) return null;

  const handleSubmit = async () => {
    if (!reason) return alert("Please select reason");
    if (selectedProductIds.length < 1) return alert("Please select an item");

    let config = {
      method: "post",
      url: Server2 + "/orders/create-dispute",
      data: {
        userId: userData?._id,
        orderId,
        productIds: selectedProductIds,
        reason,
        description,
      },
    };

    console.log(config.data)
    axios(config)
      .then(function (response) {
        setLoading(false);
        setSelectedProductIds([])
        setLockedSellerId(null)
        onClose();
      })
      .catch(function (error) {
        console.log(error);
      });

  };

  return (
    <div className="pt-2">

      <p className="px-2 text-danger fw-bold">Please share the details below to initiate a dispute.</p>

      <div style={{paddingLeft: '3px', paddingRight: '3px',}}>

        {/* Select an item */}
        <MultiSellerSelect items={items} selectedProductIds={selectedProductIds} setSelectedProductIds={setSelectedProductIds} lockedSellerId={lockedSellerId} setLockedSellerId={setLockedSellerId}/>

        <select
          className="form-select mb-3"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        >
          <option value="">Select Reason</option>
          <option value="Damaged Item">Damaged Item</option>
          <option value="Wrong Product">Wrong Product</option>
          <option value="Not Delivered">Not Delivered</option>
          <option value="Other">Other</option>
        </select>

        <textarea
          className="form-control mb-3"
          placeholder="Describe the issue..."
          rows="4"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        {/* Selected Items Preview */}
        {selectedProductIds.length > 0 && (
          <div className="mb-4 ">
            {items.filter((item) => selectedProductIds.includes(item.productId)).map((item) => (
              <div
                key={item.productId}
                className="d-flex align-items-center rounded p-2 mb-2"
              >
                <img
                  src={item.image}
                  alt={item.productName}
                  className="me-3"
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                />

                <div className="flex-grow-1">
                  <div className="fw-semibold">{item.productName}</div>
                  <small className="text-muted">
                    Qty: {item.quantity} | ${item.price}
                  </small>
                </div>

                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => {
                    const updated = selectedProductIds.filter(
                      (id) => id !== item.productId
                    );
                    setSelectedProductIds(updated);

                    if (updated.length === 0) {
                      setLockedSellerId(null);
                    }
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="d-flex justify-content-end">
        <button
          className="btn btn-secondary me-2"
          onClick={() => {
            onClose()
            setSelectedProductIds([])
            setLockedSellerId(null)
          }}
        >
          Cancel
        </button>

        <button
          className="btn ib-btn text-white"
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>


    </div>
  );
};

export default Dispute;